import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

type Props = {
  resourceLimitsField: React.ReactNode;
};

export const ResourceLimitsSettingsContainer = ({
  resourceLimitsField,
}: Props) => {
  const { title, description, docsLinkKey } =
    vpaSettingsConstants.workloadResourceLimits;

  return (
    <VerticalSettingsForm
      title={title}
      description={description}
      docsLinkKey={docsLinkKey}
    >
      {resourceLimitsField}
    </VerticalSettingsForm>
  );
};
